import { useState, useEffect } from 'react';
import Modal from './Modal';

const OWNERS = ['Jason', 'Matt', 'Both'];
const TYPES = [
  { value: 'yearly', label: 'Yearly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'monthly', label: 'Monthly' }
];

export default function DocumentModal({ isOpen, onClose, onSave, editItem = null }) {
  const [formData, setFormData] = useState({
    name: '',
    url: '',
    type: 'yearly',
    owner: 'Both',
    weekOf: ''
  });

  useEffect(() => {
    if (editItem) {
      setFormData({
        name: editItem.name || '',
        url: editItem.url || '',
        type: editItem.type || 'yearly',
        owner: editItem.owner || 'Both',
        weekOf: editItem.weekOf || ''
      });
    } else {
      setFormData({
        name: '',
        url: '',
        type: 'yearly',
        owner: 'Both',
        weekOf: ''
      });
    }
  }, [editItem, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.url.trim()) return;

    const dataToSave = { ...formData };
    // Only include weekOf for weekly documents
    if (formData.type !== 'weekly') {
      delete dataToSave.weekOf;
    }

    onSave(dataToSave);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editItem ? 'Edit Document' : 'Add Document'}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Name
          </label>
          <input
            type="text"
            placeholder="e.g., 2024 KRAs & Goals"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none focus:border-orange"
          />
        </div>

        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            URL
          </label>
          <input
            type="url"
            placeholder="https://docs.google.com/..."
            value={formData.url}
            onChange={(e) => setFormData({ ...formData, url: e.target.value })}
            required
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none focus:border-orange"
          />
        </div>

        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Type
          </label>
          <select
            value={formData.type}
            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none bg-white focus:border-orange"
          >
            {TYPES.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>


        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Owner
          </label>
          <select
            value={formData.owner}
            onChange={(e) => setFormData({ ...formData, owner: e.target.value })}
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none bg-white focus:border-orange"
          >
            {OWNERS.map((owner) => (
              <option key={owner} value={owner}>
                {owner}
              </option>
            ))}
          </select>
        </div>

        <div className="flex gap-3 mt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 px-5 bg-grey-light text-text border-none rounded-md text-sm font-medium cursor-pointer hover:bg-border"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex-1 py-3 px-5 bg-orange text-white border-none rounded-md text-sm font-medium cursor-pointer hover:bg-orange-hover"
          >
            {editItem ? 'Save Changes' : 'Add Document'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
